import api from './api';
import { DEFAULT_PUBLIC_PAGES_SETTINGS } from '../utils/publicPagesDefaults';

const CACHE_MS = 60_000;
let cached = null;
let cachedAt = 0;
let inflight = null;

export function invalidatePublicPagesCache() {
  cached = null;
  cachedAt = 0;
}

export async function fetchPublicPagesSettings({ publicAccess = false, force = false } = {}) {
  const now = Date.now();
  if (!force && cached && now - cachedAt < CACHE_MS) {
    return cached;
  }
  if (inflight) return inflight;

  const path = publicAccess ? '/public/public-pages-settings' : '/public-pages-settings';
  inflight = api
    .get(path)
    .then((response) => {
      const settings = response?.data?.settings || DEFAULT_PUBLIC_PAGES_SETTINGS;
      cached = settings;
      cachedAt = Date.now();
      return settings;
    })
    .catch(() => DEFAULT_PUBLIC_PAGES_SETTINGS)
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export async function savePublicPagesSettings(payload) {
  const response = await api.put('/public-pages-settings', payload);
  const settings = response?.data?.settings || payload;
  cached = settings;
  cachedAt = Date.now();
  return settings;
}
